import {useState} from 'react';
import {InputNumber, Modal} from 'antd';

export const TransactionAmountWidget = ({title, value, placeholder, onAmountChange, min, max, props}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [priceVal, setPriceVal] = useState(parseFloat(value));

    const onClick = () => {
        setIsModalOpen(true);
    }

    const onModalCancel = () => {
        setIsModalOpen(false);
    }

    const onModalOk = () => {
        if (onAmountChange) {
            onAmountChange(priceVal);
        }
        setIsModalOpen(false);
    }

    const onPriceValChange = (val) => {
        setPriceVal(val);
    }

    if (placeholder === undefined) {
        placeholder = "amount";
    }

    const defaultValue = (priceVal) ? priceVal.toFixed(2) : `0.00`
    return <div>
        <div onClick={onClick} style={{cursor: 'pointer', color:"#108ee9", margin: "5px"}}>{`$ ${defaultValue}`}</div>
        <Modal open={isModalOpen} onCancel={onModalCancel} onOk={onModalOk}>
            <b>{title}</b><p/>
            <InputNumber style={{width: 200}} placeholder={placeholder} addonBefore={"$"} onChange={onPriceValChange} precision={2} min={min} value={priceVal} max={max} />
        </Modal>
    </div>
}